import { createAction } from '@reduxjs/toolkit'
import { L1ChainId } from 'types'
import { ActionState } from './types'

export const updateCurrentNetwork = createAction<L1ChainId>(
  'app/updateCurrentNetwork',
)
export const updateActionState = createAction<{
  action: keyof ActionState
  state: boolean
}>('app/updateActionState')
export const updateOpenRenderFlag = createAction<{ flag: number }>(
  'app/updateOpenRenderFlag',
)
export const updateFaucetQueueLen = createAction<number>(
  'app/updateFaucetQueueLen',
)
export const updateGuideText = createAction<string>('app/updateGuideText')
